import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.SectionC1');
    return (
        <div className={`eco-content ${styles.comp}`}>
            <EcoSpace />
            <EcoSectionCard
                layout="center-left"
                title={t('title')}
                desc={t('desc')}
                lChildren={t('btn1')}
                lHref="https://jp.ecoflow.com/pages/recycling-services"
                pc={'https://websiteoss.ecoflow.com/upload/image/1745215709063/image%2018.jpg'}
                h5={'https://websiteoss.ecoflow.com/upload/image/1745215708514/Frame%201000008539.jpg'}
                lDataLayer={{
                    event: 'uaEvent',
                    event_name: 'jump_button',
                    position: 'Inpage',
                    button_name: t('btn1'),
                    url: 'https://jp.ecoflow.com/pages/recycling-services',
                }}
            />
            <EcoSpace />
        </div>
    );
}
